import React from 'react';

const siteContext = React.createContext(null);

export default siteContext;
